/* istanbul ignore file */
import React from 'react';
import { Breadcrumbs, ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useQualificationModelUrl } from 'domain/people/career/qualification/model/qualificationModelRouting';

const CompetencyBreadcrumbs = ({ children }: { children: React.ReactElement }) => {
  const { getSingleEntityUrl } = useQualificationModelUrl();

  return (
    <Breadcrumbs>
      <ListBreadcrumbItem entity="Competencies" link={getSingleEntityUrl('latest')} />
      {children}
    </Breadcrumbs>
  );
};

export default CompetencyBreadcrumbs;
